import {ChangeDetectionStrategy, Component, computed, Signal} from "@angular/core";
import {MøteLydopptakInnspillingKomponent} from "web-ng2/moduler/møte/komponenter/møte-lydopptak-innspilling/møte-lydopptak-innspilling";
import {MøteTranskripsjon} from "web-ng2/moduler/møte/tjenester/MøteTranskripsjon";

/**
 * Viser {@link MøteLydopptakInnspillingKomponent} kun mens en transkripsjon faktisk pågår,
 * se {@link MøteTranskripsjon.erIGang}, eller når opptaket stoppet uventet – da blir den stående
 * til bruker har sett hvorfor, se {@link MøteTranskripsjon.avbrudd}.
 *
 * Komponenten er ment å monteres der møtet vises – også fra ajs – og lar den som monterer den slippe
 * å holde styr på om det går et opptak. Møtet det tas opptak av kommer fra {@link MøteTranskripsjon},
 * så den som monterer komponenten trenger ikke oppgi det.
 */
@Component({
    selector: 'moete-lydopptak-innspilling-aktivert',
    templateUrl: 'møte-lydopptak-innspilling-aktivert.html',
    imports: [
        MøteLydopptakInnspillingKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteLydopptakInnspillingAktivertKomponent {
    static ajsSelector = 'moeteLydopptakInnspillingAktivert';

    /** Sann mens transkripsjonen pågår, eller den er avbrutt uten at bruker har sett hvorfor */
    readonly vises: Signal<boolean>;

    constructor(møteTranskripsjon: MøteTranskripsjon) {
        this.vises = computed(() => møteTranskripsjon.erIGang() || møteTranskripsjon.avbrudd() != null);
    }
}
